import {TeamMember} from "./members";
import {Box, Typography, useTheme} from "@mui/material";
import {darkTheme} from "../../styling/theme";
import React from "react";
import themedBoxShadow from "../../styling/themedBoxShadow";

interface MemberCardProps {
    member: TeamMember;
}

export const MemberCard: React.FC<MemberCardProps> = ({member}) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                position: "relative",
                width: 280,
                height: 360,
                overflow: "hidden",
                borderRadius: 2,
                boxShadow: themedBoxShadow(theme),
                "&:hover img": {
                    transform: "scale(1.1)",
                },
            }}
        >
            {/* Photo with zoom effect */}
            <Box
                component="img"
                src={member.photo}
                alt={member.name}
                sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.5s ease",
                }}
            />

            {/* Gradient overlay for text */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: `linear-gradient(to top, rgba(54,140,58,0.9) 0%, rgba(54,140,58,0.8) 30%, rgba(0,0,0,0) 45%)`,
                }}
            />

            {/* Overlay text forced to dark theme colors */}
            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    p: 2,
                    textAlign: "center",
                }}
            >
                <Typography
                    variant="h4"
                    sx={{color: darkTheme.palette.text.primary}} // forced dark text
                >
                    {member.name}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{color: darkTheme.palette.text.secondary}} // forced dark text
                >
                    {member.role}
                </Typography>
                <Typography
                    variant="body1"
                    sx={{color: darkTheme.palette.text.secondary}} // forced dark text
                >
                    membru din {member.year}
                </Typography>
            </Box>
        </Box>
    );
};
